import { CognitoIdentityProviderClient, GetUserCommand, UpdateUserAttributesCommand } from "@aws-sdk/client-cognito-identity-provider";
import { showSuccessSnackbar } from "../components/snackBar/snakbar";
import awsmobile from "../aws-exports";


export function copyTextToClipboard(text, successText) {
    if (!navigator.clipboard) {
        // navigator.clipboard is not available, fall back to older method
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            const successful = document.execCommand('copy');
            const msg = successful ? 'successful' : 'unsuccessful';
            if (successText)
                showSuccessSnackbar(successText)
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
        document.body.removeChild(textarea);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        if (successText)
            showSuccessSnackbar(successText)
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}
export function invokeIfCallable(callback, delay = 0, ...props) {
    if (typeof callback !== 'function') return;
    if (typeof delay !== 'number' || delay < 0) delay = 0;
    setTimeout(callback, delay, ...props);
}
export function isValidUPI(upi) {
    if (upi?.length === 0) {
        return false;
    }
    // Regular expression to match the format of UPI ID: username@bank
    const upiRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+$/;

    return upiRegex.test(upi);
}

export const getBase64 = async (input) => {
    // Convert a URL or File to base64 string

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

    if (typeof input === "string" && input.startsWith("http")) {
        try {
            const response = await fetch(input, {
                mode: "cors",            // Respect CORS
                credentials: "omit",     // Don't send cookies
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch image: ${response.status}`);
            }

            const blob = await response.blob();
            return await fileToBase64(blob);

        } catch (err) {
            if (err instanceof TypeError && err.message.includes("Failed to fetch")) {
                console.error("❌ CORS error or network failure", err);
            } else {
                console.error("❌ Unexpected error", err);
            }
            return ""; // Return empty string on failure
        }
    }

    if (input instanceof File) {
        return await fileToBase64(input);
    }

    return "";
};


export const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const getAccessToken = () => {
    let accessToken = null;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (
            key.startsWith("CognitoIdentityServiceProvider") &&
            key.endsWith(".accessToken")
        ) {
            accessToken = localStorage.getItem(key);
            break;
        }
    }
    return accessToken
}
export const getLastAuthUser = () => {
    let LastAuthUser = null;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (
            key.startsWith("CognitoIdentityServiceProvider") &&
            key.endsWith(".LastAuthUser")
        ) {
            LastAuthUser = localStorage.getItem(key);
            break;
        }
    }
    return LastAuthUser
}
export const getDeviceKey = () => {
    let deviceKey = null;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (
            key.startsWith("CognitoIdentityServiceProvider") &&
            key.endsWith(".deviceKey")
        ) {
            deviceKey = localStorage.getItem(key);
            break;
        }
    }
    return deviceKey
}

export const client = new CognitoIdentityProviderClient({ region: awsmobile.aws_project_region, UserPoolId: awsmobile.aws_user_pools_id });
export async function updateUserAttributes(payLoad) {
    const params = {
        AccessToken: getAccessToken(), // The access token of the user you're updating
        UserAttributes: payLoad
    };
    try {
        const command = new UpdateUserAttributesCommand(params);
        const response = await client.send(command);
        return response
    } catch (error) {
        console.error("Error updating user attributes:", error);
        throw Error(error)
    }
}

export const fetchUserAttribute = async () => {
    const input = { // GetUserRequest
        AccessToken: getAccessToken() // required
    };
    const command = new GetUserCommand(input);
    const response = await client.send(command);
    return response
}

export const getUserAttributes = async () => {
    try {
        const response = await fetchUserAttribute()
        console.log({ response })
        let userObject = {
            userName: response.Username,
            isGoogleUser: false,
            designation: "",
            phone_number: "",
            picture: "",
            email: "",
            idletime: 30,
            sub: '',
            isGooglePwSet: false,
            providerName: '',
            isLegacyGoogleUser: response.Username.indexOf('google') > -1,
        }
        let userAttributes = response.UserAttributes
        userAttributes.forEach(attr => {
            switch (attr.Name) {
                case 'email':
                    userObject.email = attr.Value;
                    break;
                case 'name':
                    userObject.name = attr.Value;
                    break;
                case 'custom:Designation':
                    userObject.designation = attr.Value;
                    break;
                case 'identities':
                    const identities = JSON.parse(attr.Value);
                    if (identities.length > 0) {
                        userObject.providerName = identities[0].providerName;
                        userObject.userId = identities[0].userId;
                        if (response.Username.indexOf('google') > -1) {
                            userObject.isLegacyGoogleUser = true;
                        }
                        if (identities.some((identity) => identity.providerName === 'Google')) {
                            userObject.isGoogleUser = true;
                        }
                    }
                    break;
                case 'phone_number':
                    userObject.phone_number = attr.Value;
                    break;
                case 'phone_number_verified':
                    userObject.phone_number_verified = attr.Value;
                    break;
                case 'email_verified':
                    userObject.email_verified = attr.Value;
                    break;
                case "picture":
                    userObject.picture = attr.Value;
                    break;
                case "family_name":
                    userObject.lastName = attr.Value;
                    break
                case "custom:idletime":
                    userObject.idletime = attr.Value;
                    break
                case "custom:isGooglePwSet":
                    userObject.isGooglePwSet = attr.Value === 'true';
                    break;
                case "sub":
                    userObject.sub = attr.Value;
                    break;
                default:
                    break;
            }
        });
        return userObject
    } catch (error) {
        console.error('Error refreshing token:', error);
    }
};